import { action } from 'mobx';
import { container, singleton } from 'tsyringe';

import { GridPageStoreV2 } from '../stores/category/page/grid-page-store-v2';

@singleton()
export class GridPageStoreFacade {
  public get originalStore() {
    return container.resolve(GridPageStoreV2);
  }

  public get isReady() {
    return this.originalStore.isReady;
  }

  public get railStore() {
    return this.originalStore.railStore;
  }

  public get providerLogo(): string | undefined {
    return this.originalStore.providerLogo;
  }

  @action.bound
  async init(targetGridPointer: string, targetId: string | number): Promise<void> {
    return this.originalStore.init(targetGridPointer, targetId);
  }

  @action.bound
  async onInvisible() {
    return this.originalStore.onInvisible();
  }

  @action.bound
  async resetStore() {
    return this.originalStore.resetStore();
  }
}
